import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";

import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};

type CMSInfo = {
  _id: string;
  email: string;
  phone: string;
  terms: string;
  privacyPolicy: string;
  privacyPolicy_ar: string;
  aboutUs: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  __v: number;
  dialCode: string;
  terms_ar: string;
  aboutUs_ar: string;
  id: string;
  legalPolicy: string;
  legalPolicy_ar: string;
};

export const dashboardApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query<CommonResponseType & { data: CMSInfo }, {}>({
      query: () => ({
        url: `${END_POINTS.getCms}`,
        method: "GET",
      }),
      providesTags: ["CMS"],
      keepUnusedDataFor: 300,
    }),
    updateCms: builder.mutation<CommonResponseType & { data: any }, CommonBody>(
      {
        query: (body) => ({
          url: `${END_POINTS.updateCms}`,
          method: "PUT",
          body,
        }),
        invalidatesTags: ["CMS"],
      }
    ),
    getCmsSetting: builder.query<CommonResponseType & { data: CMSInfo }, {}>({
      query: () => ({
        url: `${END_POINTS.cmsSetting}`,
        method: "GET",
      }),
      providesTags: ["CMS"],
      keepUnusedDataFor: 300,
    }),
    updateCmsSetting: builder.mutation<
      CommonResponseType & { data: any },
      CommonBody
    >({
      query: (body) => ({
        url: `${END_POINTS.cmsSetting}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["CMS"],
    }),
  }),
});
export const {
  useLazyGetCmsQuery,
  useUpdateCmsMutation,
  useGetCmsQuery,
  useLazyGetCmsSettingQuery,
  useUpdateCmsSettingMutation,
  useGetCmsSettingQuery,
} = dashboardApi;
